import React from "react";
import { X, CircleNotch } from "@phosphor-icons/react";

export function CreateTopicModal({
  show,
  onClose,
  newTopic,
  setNewTopic,
  categories,
  regions,
  onSubmit,
  submitting
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-lg">
        <div className="p-4 border-b border-[#E5E7EB] flex items-center justify-between">
          <h2 className="font-serif text-xl text-[#111827]">New Discussion Topic</h2>
          <button onClick={onClose} className="p-2 text-[#6B7280] hover:text-[#111827]">
            <X size={20} />
          </button>
        </div>
        
        <form onSubmit={onSubmit} className="p-4 space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#4B5563] mb-1">Title</label>
            <input
              type="text"
              value={newTopic.title}
              onChange={(e) => setNewTopic({ ...newTopic, title: e.target.value })}
              placeholder="What would you like to discuss?"
              className="w-full px-3 py-2 border border-[#E5E7EB] focus:outline-none focus:border-[#0F766E]"
              required
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-[#4B5563] mb-1">Category</label>
              <select
                value={newTopic.category}
                onChange={(e) => setNewTopic({ ...newTopic, category: e.target.value })}
                className="w-full px-3 py-2 border border-[#E5E7EB] focus:outline-none focus:border-[#0F766E]"
              >
                {categories
                  .filter(c => c.id !== "news")
                  .map((cat) => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))
                }
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-[#4B5563] mb-1">Region</label>
              <select
                value={newTopic.region}
                onChange={(e) => setNewTopic({ ...newTopic, region: e.target.value })}
                className="w-full px-3 py-2 border border-[#E5E7EB] focus:outline-none focus:border-[#0F766E]"
              >
                {regions.map((region) => (
                  <option key={region.id} value={region.id}>{region.name}</option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-[#4B5563] mb-1">Content</label>
            <textarea
              value={newTopic.content}
              onChange={(e) => setNewTopic({ ...newTopic, content: e.target.value })}
              placeholder="Share your thoughts, questions, or insights..."
              rows={6}
              className="w-full px-3 py-2 border border-[#E5E7EB] resize-none focus:outline-none focus:border-[#0F766E]"
              required
            />
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-[#E5E7EB] text-[#4B5563] hover:bg-[#F9FAFB]"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="px-4 py-2 bg-[#0F766E] text-white hover:bg-[#14B8A6] disabled:opacity-50 flex items-center gap-2"
            >
              {submitting && <CircleNotch size={18} className="animate-spin" />}
              Create Topic
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateTopicModal;
